/**
 * How an embryo's testing result and the lab's transfer recommendation read,
 * shared by the Embryo testing page and the embryo sheet.
 */
import type { StatusBadgeTone } from "@louise/moon-ui";
import type { EmbryoGenomicResult } from "@src/packages/cycles/hooks/useEmbryoReport";

export type EmbryoResult = EmbryoGenomicResult["result"];
export type EmbryoTransferRecommendation =
  EmbryoGenomicResult["transferRecommendation"];

export const EMBRYO_RESULTS: readonly EmbryoResult[] = [
  "euploid",
  "mosaic",
  "aneuploid",
  "no_result",
];

export const EMBRYO_RESULT_TONES: Record<EmbryoResult, StatusBadgeTone> = {
  euploid: "green",
  mosaic: "gold",
  aneuploid: "coral",
  no_result: "neutral",
};

export const EMBRYO_RESULT_LABEL_KEYS: Record<EmbryoResult, string> = {
  euploid: "care.embryo_report.result_euploid",
  mosaic: "care.embryo_report.result_mosaic",
  aneuploid: "care.embryo_report.result_aneuploid",
  no_result: "care.embryo_report.result_no_result",
};

export function countEmbryoResults(
  embryos: readonly Pick<EmbryoGenomicResult, "result">[],
): Record<EmbryoResult, number> {
  const counts: Record<EmbryoResult, number> = {
    euploid: 0,
    mosaic: 0,
    aneuploid: 0,
    no_result: 0,
  };
  for (const embryo of embryos) counts[embryo.result] += 1;
  return counts;
}
